<template>
  <div class="main-container">
    <TheSideBar>
      <router-link :to="{name: 'propertyTypeList'}">
        {{ $t('property-type.list') }}
      </router-link>
      <router-link :to="{name: 'propertyTypeNew'}">
        {{ $t('property-type.new') }}
      </router-link>
      <!-- <router-link :to="{name: 'propertyParametersEdit'}">
              {{ $t('property-type.trigger-parameters') }}
            </router-link>
            <router-link :to="{name: 'taskStateEdit'}">
              Stavy ukolu
            </router-link> -->
    </TheSideBar>
    <DataReady id="content">
      <router-view></router-view>
    </DataReady>
  </div>
</template>


<script>
import TheSideBar from 'CORE/components/side-bar/the-side-bar'
import DataReady from 'CORE/components/utilities/data-ready'

export default {
    name: 'PropertyTypesView',
    components: {
        TheSideBar,
        DataReady,
    },
}
</script>
